import LanguageIcon from "@mui/icons-material/Language";
import ListForeignLanguages from "./List";
import { FOREIGN_LANGUAGES, AdministrationServicePath } from "utils/constants";
import EditForeignLanguages from "./Edit";
import CreateForeignLanguages from "./Create";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <LanguageIcon />,
  name: AdministrationServicePath + FOREIGN_LANGUAGES,
  title: "Чужди езици",
  list: <ListForeignLanguages />,
  create: <CreateForeignLanguages />,
  edit: <EditForeignLanguages />,
  permission: permissions.canPreviewForeignLanguages,
  createPermission: permissions.canCreateForeignLanguages,
  editPermission: permissions.canUpdateForeignLanguages,
};
